<h5 class="">Payment Received Trace</h5>
@if (chartData) {
    <p-organizationChart
            [value]="chartData"
            [collapsible]="true"
            styleClass="company-chart"
            [style]="{ 'width': '100%' }">

        <ng-template pTemplate="default" let-node>
            <div class="node-content">
                <div *ngFor="let kv of node.data | keyvalue">
                    {{ kv.key }}: {{ kv.value }}
                </div>
            </div>
        </ng-template>
    </p-organizationChart>

    <!--    <p-organizationChart-->
<!--            [value]="chartData"-->
<!--            [collapsible]="true"-->
<!--            [style]="{ 'width': '100%' }"-->
<!--            styleClass="my-org-chart"-->
<!--    >-->
<!--        &lt;!&ndash; Payment Received &ndash;&gt;-->
<!--        <ng-template pTemplate="paymentReceived" let-node>-->
<!--            <div class="payment-received">-->
<!--                <h4 class="title">{{ node.data.name }}</h4>-->
<!--                <p class="text">Amount: {{ node.data.amount }} {{ node.data.currency }}</p>-->
<!--                <p class="text">Date: {{ node.data.paymentDate | date:'mediumDate' }}</p>-->
<!--                <p class="text">Type: {{ node.data.localInstrument }}</p>-->
<!--                <p class="text">Payment ID: {{ node.data.entryReference }}</p>-->
<!--                <p class="text">Bank: {{ node.data.paymentBankAccountDtoName }}</p>-->
<!--            </div>-->
<!--        </ng-template>-->

<!--        &lt;!&ndash; Customer Allocation &ndash;&gt;-->
<!--        <ng-template pTemplate="customerAllocation" let-node>-->
<!--            <div class="customer-allocation">-->
<!--                <h5 class="title">{{ node.data.customerDtoName }}</h5>-->
<!--                <p class="text">-->
<!--                    Allocated: {{ node.data.allocatedAmount }} {{ node.data.currency }}-->
<!--                </p>-->
<!--                <p class="text">Billing Run: {{ node.data.plannedPaymentDtoName }}</p>-->
<!--                <p class="text">-->
<!--                    Payment Reference: {{ node.data.paymentReceivedDtoName }}-->
<!--                </p>-->
<!--            </div>-->
<!--        </ng-template>-->

<!--        &lt;!&ndash; Customer Planned &ndash;&gt;-->
<!--        <ng-template pTemplate="customerPlanned" let-node>-->
<!--            <div class="customer-planned">-->
<!--                <h5 class="title">{{ node.data.billingRunDtoName }}</h5>-->
<!--                <p class="text">-->
<!--                    Status:-->
<!--                    <span class="status-badge">-->
<!--                    <i class="pi pi-check-circle"></i>-->
<!--                        {{ node.data.paymentStatus }}-->
<!--    </span>-->
<!--                </p>-->
<!--            </div>-->
<!--        </ng-template>-->

<!--        &lt;!&ndash; Contract Allocation &ndash;&gt;-->
<!--        <ng-template pTemplate="contractAllocation" let-node>-->
<!--            <div class="contract-allocation">-->
<!--                <h6 class="title">{{ node.data.contractDtoName }}</h6>-->
<!--                <p class="text">-->
<!--                    Allocated: {{ node.data.allocatedAmount }} {{ node.data.currency }}-->
<!--                </p>-->
<!--            </div>-->
<!--        </ng-template>-->

<!--        &lt;!&ndash; Contract Planned &ndash;&gt;-->
<!--        <ng-template pTemplate="contractPlanned" let-node>-->
<!--            <div class="contract-planned">-->
<!--                <h6 class="title">{{ node.data.plannedTypeDtoName }}</h6>-->
<!--                <p class="text">-->
<!--                    Due: {{ node.data.dueDate | date:'mediumDate' }}-->
<!--                </p>-->
<!--            </div>-->
<!--        </ng-template>-->

<!--        &lt;!&ndash; Contract (leaf) &ndash;&gt;-->
<!--        <ng-template pTemplate="contract" let-node>-->
<!--            <div class="contract-leaf">-->
<!--                <h6 class="title">{{ node.data.contractIdentifier }}</h6>-->
<!--                <p class="text">{{ node.data.comment }}</p>-->
<!--            </div>-->
<!--        </ng-template>-->
<!--    </p-organizationChart>-->

}